import { useDispatch } from "react-redux";
import { AppDispatch } from "../app/store";

export default () => useDispatch<AppDispatch>();
